/**
 * Serialize an object to a JSON-LD string safe for embedding in an inline
 * <script type="application/ld+json"> via dangerouslySetInnerHTML.
 *
 * JSON.stringify does not escape characters that are significant to the HTML
 * parser, so author-controlled text containing "</script>" (or "<!--") would
 * otherwise break out of the script tag. We escape the HTML-significant
 * characters plus the U+2028/U+2029 line separators (which are valid in JSON
 * but not in JS string literals) as Unicode escapes, which JSON readers still
 * parse back to the original characters.
 */
export function escapeJsonLd(data) {
  return JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}
